import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { homePathForRole } from "../utils/roleHome";

export default function AuthLayout() {
  const { isAuthenticated, isLoading, role } = useAuth();
  if (isLoading) {
    return (
      <div className="center-screen">
        <div className="spinner" />
      </div>
    );
  }
  if (isAuthenticated) {
    return <Navigate to={homePathForRole(role)} replace />;
  }
  return <Outlet />;
}
